import React, { createContext, ReactNode, useCallback, useEffect, useRef, useState } from 'react';
import dataStore from './dataStoreChat';
import { ChangeChatOperator, chatOfUser, CloseChat, ItenantMember, meassage, ReadChat, readMessage, receiveMessages, ReciveMessageStatus, RegisterOperatorResponse, ReplyChat, ResponseCloseChat, ResultCilentStatus, SeenMessage, SynchronizeOperatorDataItemDto, SynchronizeOperatorDataItemDtoParams, TotalCountUnReadChat, typeChatEnum, UserStatus } from './chat/inerface/iterface';
import { event } from './baseChat/interface/baseInterface';
import { BaseChat } from './baseChat/baseChat';
import { useDispatch } from 'react-redux';
import { types } from '../service/types';
import { getProfile } from '../service/actions/profileActions';
import { useSelector } from 'react-redux';
import { any, number } from 'prop-types';
import { bool, boolean } from 'yup';
import DataStore from './dataStoreChat'
// import { getTeamMembersActionRequest } from '../service/actions/teamMembersActions';
import { createObjectId } from './chat/helper';
import { useMutation } from 'react-query';
import tenantMemberService from '../service/reactQueryServices/services/tenantMemberService';

type AddItemType = (item: receiveMessages, isCurrent: boolean, isScroll: boolean) => void;
type replyChatFnType = (dto: ReplyChat) => void;
type readMessageFnType = (dto: ReadChat) => void
type getChatMessagesWithChatIdAndMessageIdFnType = (dto: readMessage) => void
type closeChatType = (userId: string, chatId: string) => void
type showType = (show: boolean) => void
type geChatsWithTenantIdType = () => void
type setSelectedTabType = (type: number | null) => void
type getOnlineClientsType = () => void
type setSelectedConversationType = (id: string | null, type: string | null) => void
type getLoadingType = () => boolean
type closeConnectionType = () => void
type seenMessageType = (dto: readMessage) => void
type setOfflineOrOnline = (chatEnable: boolean) => void
type getTotalCountUnReadChatType = () => TotalCountUnReadChat
type getUserOpenChatType = (type: number) => void
type changeChatOperatorType = (type: ChangeChatOperator) => void
type synchronizeOperatorType = (type: SynchronizeOperatorDataItemDtoParams) => void
type refreshUserNameType = () => void


type DataContextType = {
    filterData: Map<string | undefined, chatOfUser>;
    data: Map<string | undefined, chatOfUser>;
    addItem: AddItemType,
    setSelectedConversationFn: setSelectedConversationType;
    selectedConversationLocal: any,
    replyChatFn: replyChatFnType,
    seenMessageFn: seenMessageType,
    readMessageFn: readMessageFnType,
    getChatMessagesWithChatIdAndMessageIdFn: getChatMessagesWithChatIdAndMessageIdFnType,
    reconnecting: () => void,
    closeChat: closeChatType,
    show: any,
    setShow: showType,
    geChatsWithTenantId: geChatsWithTenantIdType,
    getUserOpenChat: getUserOpenChatType,
    setSelectedTab: setSelectedTabType,
    selectedTabLocal: number | null,
    getOnlineClients: getOnlineClientsType,
    connectionClose: any,
    stop: closeConnectionType,
    loadingLocal: boolean,
    getLoading: getLoadingType,
    dataStore: typeof DataStore,
    forceUpdate: () => void,
    clearData: () => void,
    setOfflineOrOnline: setOfflineOrOnline
    getTotalCountUnReadChat: getTotalCountUnReadChatType
    totalCountChat: () => string | null,
    totalCountUnReadChat: TotalCountUnReadChat,
    changeChatOperatorFn: changeChatOperatorType,
    synchronizeOperator: synchronizeOperatorType,
    refreshUserName: refreshUserNameType


}


export const DataContext = createContext<DataContextType>({
    filterData: dataStore?.getFilterData(),
    data: dataStore?.getData(),
    addItem: () => { },
    setSelectedConversationFn: () => { },
    selectedConversationLocal: any,
    replyChatFn: () => { },
    readMessageFn: () => { },

    getChatMessagesWithChatIdAndMessageIdFn: () => { },
    reconnecting: () => { },
    closeChat: () => { },
    show: any,
    setShow: () => { },
    geChatsWithTenantId: () => { },
    setSelectedTab: () => { },
    selectedTabLocal: dataStore?.getSelectedTab(),
    getUserOpenChat: () => { },
    getOnlineClients: () => { },
    connectionClose: any,
    stop: () => { },
    loadingLocal: dataStore?.getLoading(),
    getLoading: () => false,
    dataStore: DataStore,
    forceUpdate: () => { },
    seenMessageFn: () => { },
    clearData: () => { },
    setOfflineOrOnline: () => { },
    getTotalCountUnReadChat: dataStore?.getTotalCountUnReadChat,
    totalCountChat: () => "0",
    totalCountUnReadChat: {
        totalCountUnReadWaitingChat: null,
        totalCountUnReadOpenChat: null
    },
    changeChatOperatorFn: () => { },
    synchronizeOperator: () => { },
    refreshUserName: () => { }


});





export const DataProvider = ({ children }: any) => {

    const { mutateAsync: getActiveTenantMemberList, isLoading: getActiveTenantMemberListLoding } = useMutation("getActiveTenantMemberList",
        tenantMemberService.getActiveTenantMemberList);

    let configConnection: any
    const profile = useSelector((state: any) => state.profileReducer.profile)
    const [data, setData] = useState<Map<string | undefined, chatOfUser>>(dataStore.getData());
    const [filterData, setFilterData] = useState<Map<string | undefined, chatOfUser>>(dataStore?.getFilterData());

    const [selectedConversationLocal, setSelectedConversationLocal] = useState<Map<string | undefined, chatOfUser>>(dataStore?.getSelectedConversation())

    const [chatConnection, setChatConnection] = useState<BaseChat>()
    const [connectionClose, setConnectionClose] = useState(false)
    const [show, setShow] = useState(false)
    const [selectedTabLocal, setSelectedTabLocal] = useState<null | number>(null)
    const [loadingLocal, setLoadingLocal] = useState(dataStore?.getLoading())
    const [version, setVersion] = useState(0);
    const [teamMembers, setTeamMembers] = useState([])

    const [totalCountUnReadChat, setTotalCountUnReadChat] = useState<TotalCountUnReadChat>(dataStore?.getTotalCountUnReadChat())
    // const teamMembers = useSelector((state: any) => state.teamMemberReducer.list)


    const [userOffline, setUserOffline] = useState(false)
    const chatConnectionRef = useRef<BaseChat | null>(null);
    const profileRef = useRef<any>();
    const isFirstRegisterOperator = useRef(true);
    const teamMembersRef = useRef<any[] | null>(null);

    const timer = useRef<number | null>(null);
    const successRecognitions = useSelector((state: any) => state.commonReducer.successRecognitions)

    const dispatch = useDispatch()

    const addItem = (item: receiveMessages, isCurrent: boolean, isScroll: boolean) => {

        if (item?.id) {
            dataStore.addItem(item, isCurrent, isScroll);

            let _tmp = dataStore?.getSelectedConversation()
            _tmp?.forEach((_value, _key) => {
                if (_key === item?.id) {
                    setSelectedConversationFn(item?.id!, "add")
                }
            })

            const newMap = new Map(dataStore.getData());
            setData(newMap)
            setVersion((v) => v + 1)
        }

    }

    const setLoading = (loading: boolean) => {
        dataStore?.setLoading(loading)
        let tmp = dataStore?.getLoading()
        setLoadingLocal(tmp)
    }
    const getLoading = () => {
        return dataStore?.getLoading()
    }
    const setSelectedConversationFn = (id: string | null, type: string | null) => {

        dataStore?.setSelectedConversation(id, type)
        const newMap = new Map(dataStore?.getSelectedConversation())
        setSelectedConversationLocal(newMap)
    }



    const setSelectedTab = (tab: number | null) => {
        dataStore?.setSelectedTab(tab)
        let _tmp = dataStore?.getSelectedTab()
        tab !== null && localStorage?.setItem("tab", tab?.toString())
        setSelectedTabLocal(_tmp)
    }

    const getIdOperator = () => {
        let localStorageObj = localStorage.getItem("sipOnlineUser")
        let localItem = localStorageObj && JSON.parse(localStorageObj)
        let tenantId = localItem?.tenants[0]?.tenantId
        let userId = localItem?.userId
        return ({ tenantId, userId })
    }

    const getPersonalInfo = () => {
        dispatch(getProfile())
    }
    const getMemberList = async () => {
        try {
            const response = await getActiveTenantMemberList()
            if (response.status === 200) {
                setTeamMembers(response?.data)
                teamMembersRef.current = response?.data
            }
        } catch (error: any) {
            console.log("error", error)
        }

        // dispatch(getTeamMembersActionRequest({ disablePaging: true, sortText: "createDate" }))
    }

    const synchronizeOperator = (params: SynchronizeOperatorDataItemDtoParams) => {
        const conn = chatConnectionRef.current;
        conn?.send('SyncOperatorsData', params)
    }

    const getOperatorInfo = () => {
        const conn = chatConnectionRef.current;
        let idObj = getIdOperator()
        let _tmp = localStorage?.getItem("chatEnable") === null ? false : localStorage?.getItem("chatEnable") === "true" ? true : false
        _tmp && conn?.send('OperatorConnect', {
            TenantId: idObj?.tenantId,
            UserId: idObj?.userId,
            FirstName: profile?.tenantMemberFirstName ? profile?.tenantMemberFirstName : profileRef?.current?.tenantMemberFirstName,
            LastName: profile?.tenantMemberLastName ? profile?.tenantMemberLastName : profileRef?.current?.tenantMemberLastName,
            Email: profile?.email ? profile?.email : profileRef?.current?.email,
            PhoneNumber: profile?.phoneNumber ? profile?.phoneNumber : profileRef?.current?.phoneNumber,
            ProfileImageleUrl: profile?.profileUrl ? profile?.profileUrl : profileRef?.current?.profileUrl,

        })

        let operators: SynchronizeOperatorDataItemDto[] = []
        teamMembersRef?.current?.forEach((item: ItenantMember, index: number) => {
            if (item?.status !== "ActivationPending") {
                let obj = {
                    firstName: item?.firstName,
                    lastName: item?.lastName,
                    email: item?.email,
                    phoneNumber: item?.phoneNumber,
                    userId: item?.applicationUserId,
                    profileImageUrl: item?.profileUrl,

                }
                operators?.push(obj)
            }
        })

        let objFinal = {
            tenantId: idObj?.tenantId,
            operators: operators
        }
        synchronizeOperator(objFinal)
    }


    const forceUpdate = () => {
        setVersion((v: any) => v + 1)
    }

    useEffect(() => {
        if (teamMembers) {
            teamMembersRef.current = teamMembers
        }
    }, [teamMembers])

    useEffect(() => {
        let idObj = getIdOperator()
        const serverUrl = (idObj?.userId && idObj?.tenantId) ? `${process.env.REACT_APP_CHAT}/chat?sessionId=${idObj?.userId}&tenantId=${idObj?.tenantId}` : ''

        let reciveMesageEvent: event = {
            name: 'reciveMessage',
            callBack: receiveMessage as event["callBack"],
            eventValue: null,
        }

        let startCahtEvent: event = {
            name: 'userStartChat',
            callBack: startChat as event["callBack"],
            eventValue: null,
        }

        let reciveOldMessageEvent: event = {
            name: 'reciveOldMessage',
            callBack: reciveOldMessage as event["callBack"],
            eventValue: null,
        }

        let readMessageEvent: event = {
            name: 'readMessage',
            callBack: readMessage as event["callBack"],
            eventValue: null,
        }

        let registerOperatorEvent: event = {
            name: 'registerOperatorStatus',
            callBack: registerOperator as event["callBack"],
            eventValue: null,
        }

        let userStartChatStatusEvent: event = {
            name: 'userStartChatStatus',
            callBack: userStartChatStatus,
            eventValue: null,
        }

        let closeUserOpenChatEvent: event = {
            name: 'closeUserOpenChatStatus',
            callBack: closeUserOpenChatStatus as event["callBack"],
            eventValue: null,
        }
        let clientStatusEvent: event = {
            name: 'clientStatus',
            callBack: clientStatus as event["callBack"],
            eventValue: null,
        }

        let operatorStatusEvent: event = {
            name: 'operatorStatus',
            callBack: operatorStatus as event["callBack"],
            eventValue: null,
        }
        let reciveMessageStatusEvent: event = {
            name: 'reciveMessageStatus',
            callBack: reciveMessageStatus as event["callBack"],
            eventValue: null,
        }

        let seenMessageStatusEvent: event = {
            name: 'seenMessage',
            callBack: seenMessage as event["callBack"],
            eventValue: null,
        }

        let refreshChatByIdEvent: event = {
            name: 'refreshChatById',
            callBack: refreshChatById as event["callBack"],
            eventValue: null,
        }

        let setOfflineStatusEvent: event = {
            name: 'setOfflineStatus',
            callBack: setOfflineStatus as event["callBack"],
            eventValue: null,
        }

        let changeUserChatEvent: event = {
            name: 'changeUserChat',
            callBack: changeUserChat as event["callBack"],
            eventValue: null,
        }

        let syncOperatorsDataResultEvent: event = {
            name: 'syncOperatorsDataResult',
            callBack: syncOperatorsDataResult as event["callBack"],
            eventValue: null,
        }
        let arr: event[] = []
        arr.push(reciveMesageEvent)
        arr.push(startCahtEvent)
        arr.push(reciveOldMessageEvent)
        arr.push(readMessageEvent)
        arr.push(registerOperatorEvent)
        arr.push(userStartChatStatusEvent)
        arr.push(closeUserOpenChatEvent)
        arr.push(operatorStatusEvent)
        arr.push(clientStatusEvent)
        arr.push(reciveMessageStatusEvent)
        arr.push(seenMessageStatusEvent)
        arr.push(refreshChatByIdEvent)
        arr.push(setOfflineStatusEvent)
        arr.push(changeUserChatEvent)




        let timerLoading: any = null
        if (serverUrl) {
            configConnection = BaseChat.getInstance(
                serverUrl,
                arr,
                connectionFailed,
                connectionStartFailed,
                close,
                reConnected,
                reconnecting,
                stop
            )
            chatConnectionRef.current = configConnection;
            setChatConnection(configConnection)
            configConnection.startConnection()

            timerLoading = setTimeout(() => {
                getPersonalInfo()
                setSelectedTab(dataStore?.getTab())
            }, 2000)
        }

        return () => {
            if (timer.current) clearTimeout(timer.current);
            if (timerLoading) clearTimeout(timerLoading);
        }

    }, []);


    useEffect(() => {
        if (profile) {
            profileRef.current = profile
            getMemberList()
            getOperatorInfo()
        }
    }, [profile])

    const callData = () => {
        let _tmp = dataStore?.getTotalCountUnReadChat()
        if (_tmp?.totalCountUnReadOpenChat === null && _tmp?.totalCountUnReadWaitingChat === null) {
            geChatsWithTenantId()
            getUserOpenChat(0)
            getUserOpenChat(1)
        }
    }


    useEffect(() => {
        let intervalOnlineUser: any = null
        if (selectedTabLocal !== null && chatConnection) {

            intervalOnlineUser = setInterval(() => {
                getOnlineClients();
            }, 5000);
        }
        return () => {
            clearInterval(intervalOnlineUser)
        }
    }, [chatConnection, selectedTabLocal])

    const refreshUserName = () => {
        dataStore?.clear()

    }




    async function reconnectConnection() {
        try {
            await configConnection.startConnection()
            if (configConnection?.connection?.state === "Connected") {
                setConnectionClose(false)
                if (timer.current !== null) {
                    clearTimeout(timer.current)

                }
            }
            else {
                timer.current = window.setTimeout(() => reconnectConnection(), 5000)
            }
        } catch (err) {
            console.error('Error reconnecting: ', err)
        }
        getOperatorInfo()
    }

    async function close() {
        setConnectionClose(true)
        await reconnectConnection()
    }

    // برای اینکه وقتی اپراتوری به یک پیام پاسخ داد در جا بدون رفرش،  پیام در انتظار برای اپراتورهای دیگه به پیام باز انتقال داده بشه
    // این ایونت پس از 
    // replyChat 
    // ارسال میشه
    const refreshChatById = (callBackValue: any) => {
        let _tmp = callBackValue?.result?.split("-")
        if (((_tmp[0] === "WAITING" && dataStore?.getSelectedTab() === 2) || (_tmp[0] === "CLOSING" && dataStore?.getSelectedTab() === 0))) {
            dataStore?.refresh(_tmp[1], _tmp[0])
            const newMap = new Map(dataStore.getData());
            setData(newMap)
        }
    }

    const setOfflineStatus = (result: string) => {
        if (result === "ok") {
            setUserOffline(true)
        }
    }

    const changeUserChat = (callbackValue: receiveMessages[]) => {
        addItem(callbackValue[0], true, false);

    }

    const syncOperatorsDataResult = (result: receiveMessages[]) => { }


    const connectionFailed = () => {
        console.log('The hub connection failed....++++++')
        getOperatorInfo()
    }
    const connectionStartFailed = (e: any) => {
        console.log('The hub connection start failed......', e)
    }
    const reconnecting = () => {
        console.log('The hub connection reconnecting......')
        getOperatorInfo()
    }

    const stop = () => {
        let idObj = getIdOperator()
        chatConnection?.send("SetOffline", idObj?.userId, idObj?.tenantId)
    }

    const reConnected = () => {
        console.log('The hub connection reConnected......')
        getOperatorInfo()
    }

    const seenMessage = (callBackValue: receiveMessages[]) => {
        if (callBackValue[0]?.id) {
            dataStore?.seenMessage(callBackValue[0])
            const newMap = new Map(dataStore.getData());
            setData(newMap)
        }

    }

    const receiveMessage = (callBackValue: receiveMessages | receiveMessages[]) => {
        if (!Array.isArray(callBackValue)) {
            addItem(callBackValue, true, false)
        }
        else {
            chatGroupInitialization(callBackValue, "receiveMessage")
        }
        setLoading(false)
        getOperatorInfo()
    }

    const startChat = (callBackValue: receiveMessages | receiveMessages[]) => {
        if (!Array.isArray(callBackValue)) {
            addItem(callBackValue, true, false)
        }
    }

    const chatGroupInitialization = (allMessages: receiveMessages[], from: string) => {

        const _tmp = new Map<string | undefined, chatOfUser>();
        let current = from === "receiveMessage" ? true : false
        if (allMessages?.length > 0) {
            let list = from === "receiveMessage" ? [...allMessages].reverse() : allMessages
            list && list.forEach((item) => {
                addItem(item, current, false);
            })
        }
        else {
            // addItem(null, current, false);
            dataStore?.emptyTotalCountUnReadChat(from === "receiveMessage" ? 2 : 0)
        }

    }

    const getTotalCountUnReadChat = () => {
        return dataStore?.getTotalCountUnReadChat()

    }

    const reciveOldMessage = (_callBackValue: receiveMessages | receiveMessages[]) => {
        if (Array.isArray(_callBackValue)) {
            let data = dataStore?.getData()
            if (_callBackValue?.length === 1 && data.has(_callBackValue[0].id)) {
                if (_callBackValue[0]?.messages && _callBackValue[0]?.messages?.length > 0) {
                    addItem(_callBackValue[0], false, true);
                }
            }
            else {
                chatGroupInitialization(_callBackValue, "reciveOldMessage")
            }
        }
        setLoading(false)

    }

    const readMessage = (callBackValue: receiveMessages) => {
        dataStore.readMessage(callBackValue);
        const newMap = new Map(dataStore.getData());
        setData(newMap)
    }

    const registerOperator = (callBackValue: RegisterOperatorResponse) => {
        if (callBackValue?.result !== "error") {
            let _tmp = JSON.parse(callBackValue?.result?.toString())
            if (_tmp?.ID) {
                localStorage.setItem("user_chat", _tmp?.ID)
                callData()
                let tmp = localStorage?.getItem("tab")
                if (isFirstRegisterOperator.current && tmp === null) {
                    setSelectedTab(2)
                    isFirstRegisterOperator.current = false;
                }
            }
        }
    }

    const getUserOpenChat = (type: typeChatEnum) => {
        let id = localStorage.getItem("user_chat")
        const newMap = new Map();
        setFilterData(newMap)
        if (chatConnectionRef?.current?.getState()?.toString() === "Connected") {
            setLoading(true)
            let result = getIdOperator()
            id && chatConnectionRef?.current?.getUserOpenChat(id, result?.tenantId, type)
        }

    }
    const userStartChatStatus = (callBackValue: any) => {
    }

    const replyChatFn = (dto: ReplyChat) => {
        chatConnection?.send('ReplyChat', dto)
    }

    const changeChatOperatorFn = (dto: ChangeChatOperator) => {
        let result = getIdOperator()
        chatConnection?.send('ChangeChatOperator', dto?.userId, dto?.chatId, dto?.otherOperatorUserId, result?.tenantId)
    }



    const seenMessageFn = (dto: readMessage) => {
        chatConnection?.send('SeenChatMessage', dto)
    }

    const readMessageFn = (dto: ReadChat) => {
        // alert("read")
        chatConnection?.send('ReadChatMessage', dto)
    }

    const closeUserOpenChatStatus = (callbackValue: ResponseCloseChat) => {
        if (callbackValue?.result === "ok") {
            setShow(false)
            const newMap = new Map(dataStore.getData());
            setData(newMap)
        }
    }

    const getChatMessagesWithChatIdAndMessageIdFn = (readMessage: readMessage) => {
        chatConnection?.getChatMessagesWithChatIdAndMessageId(readMessage)
    }

    const reciveMessageStatus = (callBackValue: ReciveMessageStatus) => {
    }

    const operatorStatus = (callBackValue: UserStatus) => {
    }
    const clientStatus = (callBackValue: ResultCilentStatus) => {
        let _tmp: UserStatus[] = []
        if (callBackValue?.result?.length > 0) {
            let _tmp_result = JSON.parse(callBackValue?.result)

            _tmp_result?.map((item: UserStatus, index: number) => {
                _tmp.push(item)
            })
            dataStore?.detectOnlineUser(_tmp)

        }
        else {
            dataStore?.detectOnlineUser([])
        }
        const newMap = new Map(dataStore.getData());
        setData(newMap)

    }
    const closeChat = (userId: string, chatId: string) => {
        chatConnection?.send("CloseUserOpenChat", userId, chatId)
        dataStore?.removeChat(chatId)
    }

    const geChatsWithTenantId = () => {
        let result = getIdOperator()
        const newMap = new Map();
        setFilterData(newMap)
        if (chatConnectionRef?.current?.getState()?.toString() === "Connected") {
            setLoading(true)
            chatConnectionRef?.current?.send("GetChatsWithTenantID", result?.tenantId)
        }
    }

    const getOnlineClients = async () => {
        try {
            let result = getIdOperator()
            const res = await chatConnection?.send("GetOnlineClients", result?.tenantId)
        } catch (err) {
            console.error('error:', err);
        }
    };


    const clearData = () => {
        dataStore?.clear()
        const newMap = new Map(dataStore.getData());
        setData(newMap)
    }


    const setOfflineOrOnline = (chatEnable: boolean) => {
        let result = getIdOperator()
        setUserOffline(chatEnable)
        if (!chatEnable) {
            chatConnection?.send("SetOffline", result?.userId, result?.tenantId)
        }

    }

    const totalCountChat = () => {
        if (totalCountUnReadChat?.totalCountUnReadOpenChat !== null && totalCountUnReadChat?.totalCountUnReadWaitingChat !== null) {
            let tmp = totalCountUnReadChat?.totalCountUnReadOpenChat + totalCountUnReadChat?.totalCountUnReadWaitingChat
            return tmp?.toString()
        }
        else {
            return null
        }

    }
    return (
        <DataContext.Provider
            value={{
                data,
                filterData,
                addItem,
                closeChat,
                selectedConversationLocal,
                setSelectedConversationFn,
                replyChatFn,
                show,
                setShow,
                readMessageFn,
                getChatMessagesWithChatIdAndMessageIdFn,
                reconnecting,
                geChatsWithTenantId,
                selectedTabLocal,
                setSelectedTab,
                getOnlineClients,
                getUserOpenChat,
                connectionClose,
                stop,
                loadingLocal,
                getLoading,
                dataStore,
                forceUpdate,
                seenMessageFn,
                clearData,
                setOfflineOrOnline,
                totalCountChat,
                getTotalCountUnReadChat,
                totalCountUnReadChat,
                changeChatOperatorFn,
                synchronizeOperator,
                refreshUserName



            }}>
            {children}
        </DataContext.Provider>
    );
};